module.exports = __webpack_public_path__ + "ba233457d914d70459f56f419a5e7738.jpg";